import { render, staticRenderFns } from "./detailImportCusList.vue?vue&type=template&id=fe8950e6&scoped=true&"
import script from "./detailImportCusList.vue?vue&type=script&lang=js&"
export * from "./detailImportCusList.vue?vue&type=script&lang=js&"
import style0 from "./detailImportCusList.vue?vue&type=style&index=0&id=fe8950e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8950e6",
  null
  
)

export default component.exports